<template>
    <div style="padding:50px 0px;">
        <div class="tab-pane pt-3 active show" v-if="!isLoading">
            <section class="row" :class="{'section-loading': isLoading}">
                <table class="table datatable">
                    <thead>
                        <tr>
                            <th style="width:12%" class="text-center">特殊條件編號</th>
                            <th style="width:20%" class="text-center">特殊條件名稱</th>
                            <th style="width:8%" class="text-center">條件內容</th>
                            <th style="width:12%" class="text-center">最新更新日期</th>
                            <th style="width:24%" class="text-center">備註</th>
                            <th style="width:8%" class="text-center">編輯</th>
                            <th style="width:6%" class="text-center">狀態</th>
                            <th style="width:16%" class="text-center">覆核生效日期</th>
                        </tr>
                    </thead>
                    <tbody v-if="dataList.length">
                        <tr v-for="(data, i) in dataList" :key="`data-${i}`">
                          <td :key="`td1-${i}`" class="text-center">{{data.code}}</td>
                          <td :key="`td2-${i}`">{{data.code_name}}</td>
                          <td :key="`td3-${i}`" class="text-center">
                            <button type="button" class="btn btn-default btn-sm" @click="openSpecialConditionDetailModal(data.code, data.code_name)" :disabled="!data.checktimestamp">
                              查詢
                            </button>
                          </td>
                          <td :key="`td4-${i}`" class="text-center">{{data.updatetimestamp}}</td>
                          <td :key="`td5-${i}`">{{data.memo}}</td>
                          <td :key="`td6-${i}`" class="text-center">
                            <button type="button" class="btn btn-primary btn-sm" @click="openSpecialConditionEditPage(data.code)">
                              編輯
                            </button>
                          </td>
                          <td :key="`td7-${i}`">{{ data.checktimestamp ? "已生效" : "未生效" }}</td>
                          <td :key="`td8-${i}`" class="text-center">{{data.checktimestamp}}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td class="text-center" colspan="7">
                                <h4 class="mb-3">查無資料</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
            <div style="height:30px"></div>
        </div>
        <div v-else>
            <Message
            class="mt-5 d-flex justify-content-center"
            loading
            message="資料讀取中，請稍候..."
            />
        </div>
        <SpecialConditionDetailModal
          :open="specialConditionDetailModalOpen"
          :code="detail.code"
          :codename="detail.codename"
          @confirm="panelClose('specialConditionDetailModalOpen')"
        ></SpecialConditionDetailModal>
    </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import Message from "@/desktop/components/Message.vue";
import SpecialConditionDetailModal from "./components/SpecialConditionDetailModal.vue";
import { getSpecialConditionsList } from "@/service";


export default {
  name: "CoverageSpecialConditionGroup",
  mixins: [commonMixin],
  components: {
    Message,
    SpecialConditionDetailModal,
  },
  props: {
    reload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      dataList: [],
      specialConditionDetailModalOpen: false,
      detail: {
        code: "",
        codename: "",
      }
    };
  },
  watch: {
    reload(val) {
      if (val) {
        this.getData();
      }
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      await getSpecialConditionsList(this.$store.state.userInfo.id).then((result) => {
        if (result.header && result.header.status == "200") {
          this.dataList = result.data;
        } else {
          this.dataList = [];
        }
        this.isLoading = false;
      });
    },
    openSpecialConditionDetailModal(code, codename) {
      this.detail.code = code;
      this.detail.codename = codename;
      this.panelOpen('specialConditionDetailModalOpen');
    },
    /** 打開特殊條件編輯頁 */
    openSpecialConditionEditPage(code) {
      this.$router.push({ name: 'SpecialConditionDetailEdit', params: {code: code} })
    },
  },
};
</script>

